import {
  bool, number, shape, string,
} from 'prop-types';
import React from 'react';
import { StyleSheet, View } from 'react-native';

import { SHAPE } from '../../../../common';
import { Location } from '../../../../components';
import { LAYOUT } from '../../../../reactor/common';
import {
  Image, Motion, Text, Video,
} from '../../../../reactor/components';
import styles from './Media.style';


const Media = ({
  image, location, motion, rights, text, title, video, viewed, visibility, ...inherit
}) => {
  const { PORTRAIT, H, W } = LAYOUT.VIEWPORT;
  const motionTextOpacity = { property: 'opacity', value: viewed || visibility >= 0.33 ? 1 : 0 };

  return (
    <View style={styles.container}>
      { title
        && (
        <Motion
          disabled={!motion || PORTRAIT}
          style={styles.motion}
          timeline={[
            motionTextOpacity,
            { property: 'top', value: viewed || visibility >= 0.33 ? 0 : -H / 3 },
          ]}
        >
          <Text
            color={inherit.color}
            headline
            level={PORTRAIT ? 2 : 0}
            style={StyleSheet.flatten([styles.title, image && styles.titleWithImage])}
          >
            {title}
          </Text>
        </Motion>
        ) }

      { text
        && (
        <Motion
          disabled={!motion}
          style={StyleSheet.flatten([styles.motion, !PORTRAIT && { maxWidth: '50%' }])}
          timeline={[
            motionTextOpacity,
            { property: 'scale', value: viewed || visibility >= 0.33 ? 1 : 0.95 },
          ]}
        >
          <Text headline level={PORTRAIT ? 4 : 2} color={inherit.color}>
            {text}
          </Text>
        </Motion>
        )}

      { (video || image)
        && (
        <Motion
          disabled={!motion}
          style={styles.motion}
          timeline={[
            { property: 'bottom', value: viewed || visibility >= 0.66 ? 0 : -H },
          ]}
        >
          { video
            && (
            <Video
              autoPlay={visibility > 0.75}
              controls
              source={video}
              height={PORTRAIT ? H / 3.75 : H * 0.75}
              width={PORTRAIT ? W * 0.85 : W * 0.75}
            />
            ) }
          { image
            && (
            <Image
              ratio={PORTRAIT ? 2 : 1}
              resizeMode="cover"
              responsive
              source={{ uri: image }}
              style={StyleSheet.flatten([styles.image, { width: W, height: H }])}
            />
            ) }
        </Motion>
        ) }

      { location && !rights
        && <Location {...location} color={inherit.color} style={styles.location} /> }

      { rights
        && (
        <Text caption color={inherit.color} style={styles.rights}>
          {rights}
        </Text>
        ) }
    </View>
  );
};

Media.propTypes = {
  image: string,
  location: shape(SHAPE.LOCATION),
  motion: bool,
  rights: string,
  text: string,
  title: string,
  video: string,
  viewed: bool,
  visibility: number.isRequired,
};

Media.defaultProps = {
  image: undefined,
  location: undefined,
  motion: true,
  rights: undefined,
  text: undefined,
  title: undefined,
  viewed: undefined,
  video: undefined,
};

export default Media;
